export { default as MenuPanel } from './component'
